import { cx } from '@linaria/core';
import { getCaptionValue } from '@pm2/content-engine';
import { pm2ConfigStore, usePM2DisplayContext } from '@pm2/store';
import { resets } from '@ui/css';
import { Tooltip } from '@ui/kit';
import { useResolvedDisplayData } from '../../hook.resolve-display-data.js';
import { Caption } from './atoms/caption.js';
import { CardPreview } from './atoms/card.js';
import { componentWrapperCls } from './embed-iframe.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Boundary } from '../../molecules/embed-iframe/comp.boundary.js';
import { PostloadedIframe } from '../../molecules/embed-iframe/atom.postloaded-iframe.js';
import { IframeComponentContent } from '../../molecules/embed-iframe/comp.content.js';
import { Scrambled } from '../../molecules/embed-iframe/atom.scrambled.js';

const EmbedIframeComponentSelector = "embed-iframe-component";
function EmbedIframeComponent(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const loginDisabled = pm2ConfigStore.useSelector(state => state.config.settings.loginDisabled);
  const badgeImage = pm2ConfigStore.useSelector(state => state.config.theme.componentPreviewImage);
  const {
    inLightbox
  } = usePM2DisplayContext();
  const [displayData, failed, retry] = useResolvedDisplayData(props.getDisplayData, props.learningObjectId);

  // In case the component should be opened in a lightbox, then do not bother
  // rendering anything aport from the iframe
  if (inLightbox && !props.isScrambled) {
    return /*#__PURE__*/jsx(Boundary, {
      hasPreviewImage: false,
      previewImageDimensions: undefined,
      forceOpenInLightbox: true,
      displayData: displayData,
      inLightbox: true,
      children: /*#__PURE__*/jsx(PostloadedIframe, {
        src: displayData?.src,
        title: props.caption.title?.value
      })
    });
  }
  let content;
  if (props.isScrambled) {
    content = /*#__PURE__*/jsx(Scrambled, {});
  } else if (
  // In case a custom preview has been uploaded for the iframe then ensure
  // that the IframeComponentContent will be rendered no matter what, since
  // custom images takes presedent over the default Badge rendering.
  props.autoActivate || !badgeImage && !props.previewImageSrc) {
    content = /*#__PURE__*/jsx(IframeComponentContent, {
      title: getCaptionValue(props.caption.title),
      learningObjectId: props.learningObjectId,
      autoActivate: props.autoActivate ?? false,
      target: props.target,
      displayData: displayData,
      retryFetchingDisplayData: retry,
      failedFetchingDisplayData: failed,
      contentType: props.contentType
    });
  } else {
    content = /*#__PURE__*/jsx(CardPreview, {
      title: getCaptionValue(props.caption.title),
      description: props.lightboxDescription,
      indexOrLevel: props.indexOrLevel,
      target: props.target,
      displayData: displayData,
      badgeImage: badgeImage,
      previewImageSrc: props.previewImageSrc
    });
  }
  return /*#__PURE__*/jsx(Tooltip, {
    disabled: !loginDisabled,
    placement: "top",
    body: "Denne funktion kan ikke tilg\xE5s i \xF8jeblikket, da vi har problemer med login.",
    ariaType: "description",
    children: ref => /*#__PURE__*/jsxs("section", {
      ref: ref,
      "data-component-type": EmbedIframeComponentSelector,
      className: cx("gIframe", resets.rootCls, componentWrapperCls, props.displayCaption === "above" && "captionOnTop", props.displayCaption === "below" && "captionOnBottom", props.isScrambled && "gIframe--scrambled", audience === "Grade1To3" && "simple", badgeImage && "withBadgeImage"),
      children: [props.displayCaption === "above" && /*#__PURE__*/jsx(Caption, {
        position: "above",
        caption: props.caption,
        scrambled: props.isScrambled
      }), content, props.displayCaption === "below" && /*#__PURE__*/jsx(Caption, {
        position: "below",
        caption: props.caption,
        scrambled: props.isScrambled
      })]
    })
  });
}

export { EmbedIframeComponent, EmbedIframeComponentSelector };
//# sourceMappingURL=embed-iframe.js.map
